(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    class CartDrawer extends HTMLElement {
    connectedCallback() {
      this.itemsWrap = this.querySelector('[data-cart-items]');

      document.addEventListener('submit', this.onSubmit.bind(this), true);
      document.addEventListener('click', this.onDocClick.bind(this), true);
      document.addEventListener('keydown', this.onKey.bind(this));
      this.addEventListener('click', this.onClick.bind(this));

      var upsellBtn = this.querySelector('[data-cart-upsell-add]');
      if (upsellBtn) upsellBtn.addEventListener('click', this.addUpsell.bind(this));
    }

    onSubmit(event) {
      var form = event.target;
      if (!form.action || form.action.indexOf('/cart/add') === -1) return;
      if (form.querySelector('[name="return_to"]')) return;

      event.preventDefault();
      var data = new FormData(form);
      var items = [];
      data.forEach(function (value, key) {
        var match = key.match(/^items\[(\d+)\]\[(id|quantity)\]$/);
        if (!match) return;
        var index = parseInt(match[1], 10);
        items[index] = items[index] || {};
        items[index][match[2]] = parseInt(value, 10);
      });
      items = items.filter(function (item) { return item && item.id; });
      if (!items.length && data.get('id')) {
        items = [{ id: parseInt(data.get('id'), 10), quantity: parseInt(data.get('quantity'), 10) || 1 }];
      }
      if (!items.length) return;

      this.request('/cart/add.js', { items: items });
    }

    onDocClick(event) {
      var link = event.target.closest('a.header__cart');
      if (!link) return;
      event.preventDefault();
      this.refresh(true);
    }

    onClick(event) {
      if (event.target.closest('[data-cart-drawer-close]')) {
        this.close();
        return;
      }

      var stepBtn = event.target.closest('[data-cart-line-change]');
      if (stepBtn) {
        this.request('/cart/change.js', {
          line: parseInt(stepBtn.dataset.line, 10),
          quantity: parseInt(stepBtn.dataset.quantity, 10)
        });
      }
    }

    onKey(event) {
      if (event.key === 'Escape') this.close();
    }

    addUpsell() {
      this.request('/cart/add.js', {
        items: [{ id: parseInt(this.dataset.upsellVariant, 10), quantity: 1 }]
      });
    }

    request(url, payload) {
      var self = this;
      fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (response) {
          if (!response.ok) throw new Error('cart request failed');
          return self.refresh(true);
        })
        .catch(function () {
          window.location.href = '/cart';
        });
    }

    refresh(open) {
      var self = this;
      return fetch('/cart.js')
        .then(function (response) { return response.json(); })
        .then(function (cart) {
          self.render(cart);
          if (open) self.open();
        });
    }

    money(cents) {
      var value = cents / 100;
      return '$' + (value % 1 === 0 ? value.toFixed(0) : value.toFixed(2));
    }

    render(cart) {
      var self = this;

      // Line items
      if (!cart.items.length) {
        this.itemsWrap.innerHTML = '<p class="cart-drawer__empty">' + this.dataset.msgEmpty + '</p>';
      } else {
        this.itemsWrap.innerHTML = cart.items.map(function (item, index) {
          var line = index + 1;
          var compare = '';
          if (item.original_line_price > item.final_line_price) {
            compare = '<s class="cart-drawer__item-compare">' + self.money(item.original_line_price) + '</s>';
          }
          return (
            '<div class="cart-drawer__item">' +
              (item.image ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?|$)/, '_120x$1$2') + '" alt="" loading="lazy">' : '') +
              '<div class="cart-drawer__item-info">' +
                '<p class="cart-drawer__item-title">' + item.product_title + '</p>' +
                (item.variant_title ? '<p class="cart-drawer__item-variant">' + item.variant_title + '</p>' : '') +
                '<div class="cart-drawer__item-qty">' +
                  '<button type="button" data-cart-line-change data-line="' + line + '" data-quantity="' + (item.quantity - 1) + '">&minus;</button>' +
                  '<span>' + item.quantity + '</span>' +
                  '<button type="button" data-cart-line-change data-line="' + line + '" data-quantity="' + (item.quantity + 1) + '">+</button>' +
                  '<button type="button" class="cart-drawer__item-remove" data-cart-line-change data-line="' + line + '" data-quantity="0">' + self.dataset.labelRemove + '</button>' +
                '</div>' +
              '</div>' +
              '<div class="cart-drawer__item-price">' + compare + '<span>' + self.money(item.final_line_price) + '</span></div>' +
            '</div>'
          );
        }).join('');
      }

      // Subtotal
      this.querySelector('[data-cart-subtotal]').textContent = this.money(cart.total_price);

      // Upsell row: hide when empty cart or already added
      var upsell = this.querySelector('[data-cart-upsell]');
      if (upsell) {
        var upsellProductId = parseInt(this.dataset.upsellProduct, 10);
        var alreadyAdded = cart.items.some(function (item) { return item.product_id === upsellProductId; });
        upsell.hidden = !cart.items.length || alreadyAdded;
      }

      // Header count
      var cartLink = document.querySelector('a.header__cart');
      if (cartLink) {
        var count = cartLink.querySelector('.header__cart-count');
        if (!count && cart.item_count > 0) {
          count = document.createElement('sup');
          count.className = 'header__cart-count';
          cartLink.appendChild(count);
        }
        if (count) {
          count.textContent = cart.item_count;
          count.hidden = cart.item_count === 0;
        }
      }
    }

    open() {
      this.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }

    close() {
      this.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  }

  customElements.define('cart-drawer', CartDrawer);
  } catch(e) { console.error(e); }
})();

})();
